import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '../../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "googlePayInvalidAddressModal" */ './GooglePayInvalidAddressModal')));

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'GooglePayInvalidAddressModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as GooglePayInvalidAddressModal };
